export const KB = 1024;

export const MB = 1024 * KB;

export const GB = 1024 * MB;

export const TRANSFER_LIMIT_FOR_ALL = 200 * GB;

export const UNLIMITED_TRANSFER_LIMIT: string | number = null;

export const TOOLTIP_EXPERIMENT_TRANSFER_LOWER_LIMIT = 750 * MB;

export const TOOLTIP_EXPERIMENT_TRANSFER_UPPER_LIMIT = 2 * GB;
